import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Badge,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  Form,
  InputGroup,
} from "reactstrap"
import Select from "react-select"
import MetaTags from "react-meta-tags"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {
  getChangeSeasonUsers as onGetUsers,
  updateUser as onUpdateUser,
  updateUserSeasonChange as onUpdateUserSeasonChange,
  deleteUser as onDeleteUser,
  resetData,
  clearMessage,
} from "store/user/actions"
import { getSettingData } from "../../store/settings/actions"
import { getSeasonPasses as onGetSeasonPasses } from "store/season-pass/actions"
import { getRoles as onGetRoles } from "../../store/roles/actions"
import { isEmpty, map, orderBy } from "lodash"
import * as Yup from "yup"
import { useFormik } from "formik"
import { dateformat } from "config"
import DeleteModal from "components/Common/DeleteModal"
import toastr from "toastr"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import "toastr/build/toastr.min.css"
//redux
import { useSelector, useDispatch } from "react-redux"
import {
  guestAccessType,
  statusTypes,
  messageTitle,
  vehicleTypes,
} from "constants/common"
import moment from "moment"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import { mobileRegex, iuRegex,vehicleRegex,numRegex } from "../../helpers/validator"

const sizePerPage = 25

const defaultDate = moment()

const getColor = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return "danger"
  } else if (
    status == statusTypes.Approved ||
    status == statusTypes.Available
  ) {
    return "success"
  } else if (status == statusTypes.Blacklist) {
    return "dark"
  } else {
    return "warning"
  }
}

const getSeason = seasonPass => {
  if (seasonPass) {
    return {
      value: seasonPass?._id || "",
      label: seasonPass?.seasonTitle || "",
    }
  }
  return null
}

const getRequestedSeason = seasonPass => {
  if (seasonPass) {
    let seasonRequested = seasonPass.find(el => {
      if (el.status === "Pending") {
        return el
      }
    })
    return {
      value: seasonRequested?.newSeason,
      label: seasonRequested?.seasonTitle,
    }
  }
}

const getRole = role => {
  if (role) {
    return {
      value: role?._id || "",
      label: role?.roleTitle || "",
    }
  }
  return null
}

const checkStatus = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return true
  } else {
    return false
  }
}


const getScheduleChangeDate = user => {
  if (!isEmpty(user)) {
    const schedule = Object.keys(user?.scheduled || []).find(
      el => el.updateField == "name"
    )
    if (schedule && !isEmpty(schedule)) {
      return schedule.dateScheduled
    }
  }
  return defaultDate
}
const getPMS = user => {
  if (!isEmpty(user)) {
    return {
      value: user?.primaryStation || "",
      label: user?.primaryStation || "",
    }
  }
  return null
}

function UserDetailChangeApproval(props) {
  const dispatch = useDispatch()
  const [user, setUser] = useState()
  const [currentPage, setCurrentPage] = useState(1)
  const [modal, setModal] = useState(false)
  const [reasonText, setReasonText] = useState("");
  const [isEdit, setIsEdit] = useState(false)
  const [selectedRole, setSelectedRole] = useState(getRole(user?.role || null))
  const [selectedSeason, setSeason] = useState(getSeason(user?.season || null))
  const [selectedRequestedSeason, setRequestedSeason] = useState()
  // const [requestedSeasonType, setRequestedSeasonType] = useState()
  const [vehicleType, setVehicleType] = useState(vehicleTypes.car)
  const [scheduleChange, setScheduleChange] = useState(false)
  const [selectedPMS, setPMS] = useState(getPMS(user))
  const [customValidation, setCustValidation] = useState({
    validPMS: true,
  })
  const [loading, setLoading] = useState(false)
  const [primaryStations, setPrimaryStations] = useState([])
  useEffect(() => {
    setRequestedSeason(getRequestedSeason(user?.changeSeason))
  }, [user])
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (user && user.name) || "",
      department: (user && user.department) || "",
      email: (user && user.email) || "",
      mobileNumber: (user && user.mobileNumber) || "",
      vehicleNumber: (user && user.vehicleNumber) || "",
      inVehicleUnit: (user && user.inVehicleUnit) || "",
      tempVehicleExpiryDate: (user && user.tempVehicle && user.tempVehicle.endDate) || null,
      tempVehicleNo: (user && user.tempVehicle && user.tempVehicle.tempVehicleNo) || "",
      tempInVehicleUnit: (user && user.tempVehicle && user.tempVehicle.tempInVehicleUnit) || "",
      tempVehicleReason: (user && user.tempVehicle && user.tempVehicle.reason) || "",
      scheduleChangeDate: convertUtcToLocal(
        getScheduleChangeDate(user || null)
      ),
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Please Enter Your Name")
        .min(5, "Must be at least 5 characters"),
      mobileNumber: Yup.string()
        .required("A valid Mobile Number is required")
        .matches(mobileRegex, "Invalid Mobile Number")
        .min(8, "Invalid Mobile Number")
        .max(8, "Invalid Mobile Number"),
      email: Yup.string()
        .required("Please Enter Your Email")
        .email("A valid Corporate Email is required")
        .max(255),
      vehicleNumber: Yup.string()
        .required("A valid Vehicle Number is required")
        .matches(vehicleRegex,"Invalid Vehicle Number")
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      inVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
      tempVehicleNo: Yup.string()
        .matches(vehicleRegex,"Invalid Vehicle Number")
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      tempInVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
      tempVehicleExpiryDate: Yup.date().nullable(),
    }),
    onSubmit: values => {
      if (isEdit) {
        let updateUser = {
          id: user.id,
          name: values.name,
          role: selectedRole?.value || "",
          season: selectedSeason?.value || "",
          newSeason: selectedRequestedSeason?.value || "",
          corporateEmail: values.email,
          department: values.department,
          mobileNumber: values.mobileNumber,
          inVehicleUnit: values.inVehicleUnit,
          vehicleNumber: values.vehicleNumber,
          primaryStation: selectedPMS?.value || "",
          vehicleType,
        }
        if (scheduleChange) {
          let _scheduleObj = []
          if (user?.name != updateUser?.name) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "name",
              updateData: updateUser?.name,
            })
            delete updateUser?.name
          }
          if (user?.role?._id != updateUser?.role) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "role",
              updateData: updateUser?.role,
            })
            delete updateUser?.role
          }
          if (user?.season?._id != updateUser?.season) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "season",
              updateData: updateUser?.season,
            })
            delete updateUser?.season
          }
          if (user?.corporateEmail != updateUser?.corporateEmail) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "corporateEmail",
              updateData: updateUser?.corporateEmail,
            })
            delete updateUser?.corporateEmail
          }
          if (user?.department != updateUser?.department) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "department",
              updateData: updateUser?.department,
            })
            delete updateUser?.department
          }
          if (user?.mobileNumber != updateUser?.mobileNumber) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "mobileNumber",
              updateData: updateUser?.mobileNumber,
            })
            delete updateUser?.mobileNumber
          }
          if (user?.inVehicleUnit != updateUser?.inVehicleUnit) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "inVehicleUnit",
              updateData: updateUser?.inVehicleUnit,
            })
            delete updateUser?.inVehicleUnit
          }
          if (user?.vehicleNumber != updateUser?.vehicleNumber) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "vehicleNumber",
              updateData: updateUser?.vehicleNumber,
            })
            delete updateUser?.vehicleNumber
          }
          if (user?.primaryStation != updateUser?.primaryStation) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "primaryStation",
              updateData: updateUser?.primaryStation,
            })
            delete updateUser?.primaryStation
          }

          if (!isEmpty(_scheduleObj)) {
            updateUser = {
              ...updateUser,
              scheduled: _scheduleObj,
            }
          }
        }
        if (
          !isEmpty(values.tempInVehicleUnit) &&
          !isEmpty(values.tempVehicleExpiryDate) &&
          !isEmpty(tempVehicleReason)
        ) {
          updateUser = {
            ...updateUser,
            tempVehicle: {
              startDate: convertDateToUtc(defaultDate),
              endDate: convertDateToUtc(values.tempVehicleExpiryDate),
              tempInVehicleUnit: values.tempInVehicleUnit,
              tempVehicleNo: values.tempVehicleNo,
              reason: values.tempVehicleReason,
              status: "Approved",
            },
          }
        }
        // update user
        setLoading(true)
        dispatch(onUpdateUser(updateUser))
        validation.resetForm()
        setIsEdit(false)
      } else {
        const newUser = {
          name: values["name"],
          role: selectedRole?.value || "",
          season: selectedSeason?.value || "",
          newSeason: selectedRequestedSeason?.value || "",
          corporateEmail: values["email"],
          department: values["department"],
          mobileNumber: values["mobileNumber"],
          vehicleNumber: values["vehicleNumber"],
          inVehicleUnit: values["inVehicleUnit"],
          tempVehicle: null,
          scheduled: null,
          transactions: null,
          status: "Approved",
          primaryStation: selectedPMS?.value || "",
          vehicleType,
        }
        setLoading(true)
        // save new user
        dispatch(onAddNewUser(newUser))
      }
      toggle()
    },
  })

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const handleDeleteUser = () => {
    setLoading(true)
    if (user.action == "delete") {
      dispatch(onDeleteUser(user))
    } else if (user.action == "approve") {
      const updateUser = {
        id: user._id,
        status: statusTypes.Approved,
      }
      dispatch(onUpdateUser(updateUser))
    } else {
      dispatch(onDeleteUser(user))
    }
    //onPaginationPageChange(currentPage)
    setDeleteModal(false)
  }

  const {
    users,
    roleList,
    message,
    pagination,
    error,
    settingData,
    // seasonPassList,
    seasonPassData,
  } = useSelector(state => ({
    users: state.users.userChangeSeasonList,
    pagination: state.users.pagination,
    message: state.users.message,
    error: state.users.error,
    roleList: state.roles.roleList,
    settingData: state.Settings.settingData,
    // seasonPassList: state.seasonPass?.seasonPassList || [],
    seasonPassData: state.seasonPass.seasonPassList,
  }))

  const getSeasonById = id => {
    if (seasonPassData) {
      const season = seasonPassData.find(el => el._id == id)
      if (season) {
        return season
      }
    }
    return null
  }

  const { SearchBar } = Search
  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0,
    custom: true,
    totalPages: pagination?.totalPages || 0,
  }
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  useEffect(() => {
    if (isEmpty(seasonPassData)) {
      dispatch(onGetSeasonPasses())
    }
  }, [dispatch, seasonPassData])

  useEffect(() => {
    dispatch(
      onGetUsers({
        status: [statusTypes.Approved, statusTypes.Available],
        seasonChangeStatus: statusTypes.Pending,
      })
    )
  }, [selectedRequestedSeason])

  useEffect(() => {
    if (isEmpty(seasonPassData)) {
      dispatch(onGetSeasonPasses())
    }
  }, [seasonPassData])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  useMemo(() => {
    if (message) {
      toastr.success(message, messageTitle)
      dispatch(
        onGetUsers({
          status: [statusTypes.Approved, statusTypes.Available],
          seasonChangeStatus: statusTypes.Pending,
        })
      )
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  const handleUpdateClick = () => {
    const changeSeason = (user.changeSeason || []).find(
      el => el.status == statusTypes.Pending
    )
    if (changeSeason) {
      let updateUser = {
        id: user._id,
        changeSeasonId: changeSeason._id,
        status: user.approvedStatus,
        statusChangeReason: reasonText,
      }
      dispatch(onUpdateUserSeasonChange(updateUser))
      // setModal(false)
      setDeleteModal(false)
    }
  }

  // const handleUpdateClick = () => {
  //   let updateUser = {
  //     status: user.status,
  //     id: user._id,
  //     statusChangeReason: reasonText,
  //   }
  //   dispatch(onUpdateUser(updateUser))
  //   setDeleteModal(false)
  // }

  // const getSeasonById = id => {
  //   if (seasonPassData) {
  //     const season = seasonPassData.find(el => el._id == id)
  //     if (season) {
  //       return season
  //     }
  //   }
  //   return null
  // }

  const userListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user._id}</>,
    },
    {
      text: "User ID",
      dataField: "userId",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user.userId}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.name}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.role?.roleTitle || ""}</p>
        </>
      ),
    },
    {
      text: "Employment Details",
      dataField: "department",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user?.primaryStation || ""}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.department || ""}</p>
        </>
      ),
    },
    {
      dataField: "corporateEmail",
      text: "Contact Details",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.mobileNumber}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.corporateEmail || ""}</p>
        </>
      ),
    },
    {
      dataField: "vehicleNumber",
      text: "Vehicle Details",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user?.vehicleNumber || ""}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.inVehicleUnit || ""}</p>
        </>
      ),
    },
    {
      dataField: "newSeason",
      text: "Season Changes",
      sort: true,
      formatter: (cellContent, user) => {
        const pendingSeason = (user?.changeSeason || []).find(el => {
          if (el.status === guestAccessType.Pending) {
            return el
          }
        })
        return (
          <>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {user?.season?.seasonTitle || ""}
              </Link>
            </h5>
            <p className="text-muted mb-0">{pendingSeason?.seasonTitle || ""}</p>
          </>
        )
      },
    },
    {
      text: "New Season Start",
      dataField: "seasonStart",
      sort: true,
      formatter: (cellContent, user) => {
        const pendingSeason = (user?.changeSeason || []).find(el => {
          if (el.status === guestAccessType.Pending) {
            return el
          }
        })
        return (
          <div style={{ whiteSpace: "normal" }}>
            {moment(pendingSeason?.seasonStart || new Date()).format(
              "YYYY-MM-DD"
            )}
          </div>
        )
      },
    },
    {
      dataField: "status",
      text: "User Status",
      sort: true,
      formatter: (cellContent, user) => (
        <Badge className={"bg-" + getColor(guestAccessType.Pending)}>{guestAccessType.Pending}</Badge>
      ),
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => {
        const pendingSeason = (user?.changeSeason || []).find(el => {
          if (el.status === guestAccessType.Pending) {
            return el
          }
        })
        return (
        <div className="d-flex gap-3">
          {/* <Link
            className="text-primary"
            to="#"
            style={{
              opacity: checkStatus(user?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(user?.status) ? "none" : "auto",
            }}
          >
            <i
              className="mdi mdi-account-edit font-size-24"
              id="edittooltip"
              // style={{ opacity: "0.4", cursor: "default" }}
              onClick={e => handleUserClick(user)}
              data-toggle="tooltip"
              data-placement="top"
              title="Update User"
            ></i>
          </Link> */}
          <Link className="text-success" to="#"
          style={{
            opacity: moment().startOf("D").diff(moment(pendingSeason?.seasonStart),"days")>0 || 
                     moment(user?.nextBillDate).diff(moment(pendingSeason?.seasonStart),"days")>0  ? "0.4" : 5,
            pointerEvents: moment().startOf("D").diff(moment(pendingSeason?.seasonStart),"days")>0 || 
            moment(user?.nextBillDate).diff(moment(pendingSeason?.seasonStart),"days")>0 ? "none" : "auto",
          }}>
            <i
              className="mdi mdi-account-check font-size-24"
              id="tooltip"
              onClick={() =>
                handleApproveRejectClick(user, statusTypes.Approved)
              }
              data-toggle="tooltip"
              data-placement="top"
              title="Approve Season Change"
            ></i>
          </Link>
          <Link className="text-dark" to="#">
            <i
              className="mdi mdi-account-remove font-size-24"
              id="deletetooltip"
              onClick={() =>
                handleApproveRejectClick(user, statusTypes.Removed)
              }
              data-toggle="tooltip"
              data-placement="top"
              title="Deny Season Change"
            ></i>
          </Link>
        </div>
      )}
    },
  ]

  useEffect(() => {
    setLoading(true)
    dispatch(getSettingData())
    // dispatch(onGetUsers())
    dispatch(onGetRoles())
    dispatch(
      onGetSeasonPasses({
        status: statusTypes.Available,
        vehicletype: vehicleType,
      })
    )
    return function cleanup() {
      dispatch(resetData())
    }
  }, [])

  useEffect(() => {
    if (settingData["cpfProperties"]) {
      const { cpfBuilding } = settingData["cpfProperties"]
      const list = !isEmpty(cpfBuilding) ? cpfBuilding.split(`,`) : []
      setPrimaryStations(list)
    }
  }, [settingData])

  const toggle = () => {
    setModal(!modal)
  }

  const handleApproveRejectClick = (user, status) => {
    setDeleteModal(true)
    setUser({ ...user, approvedStatus: status })
  }

  const handleUserClick = arg => {
    const user = arg
    setUser({
      ...user,
      id: user._id,
      name: user.name,
      currentSeasonType: user.currentSeasonType,
      seasonType: user.seasonType,
      email: user.corporateEmail,
      department: user.department,
      mobileNumber: user.mobileNumber,
      vehicleNumber: user.vehicleNumber,
      inVehicleUnit: user.inVehicleUnit,
    })
    setSelectedRole(getRole(user?.role || null))
    setSeason(getSeason(user?.season || null))
    setRequestedSeason(getRequestedSeason(user?.changeSeason || null))
    setIsEdit(true)
    setScheduleChange(user?.scheduled ? true : false)
    setPMS(getPMS(user))
    if (user.vehicleType == vehicleTypes.bike) {
      setVehicleType(vehicleTypes.bike)
    } else {
      setVehicleType(vehicleTypes.car)
    }
    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const keyField = "_id"
  const roleOptions = (roleList || []).map(el => ({
    value: el._id,
    label: el.roleTitle,
  }))
  // const _seasonPasses = (seasonPassList || []).filter(el => {
  //   if (selectedRole) {
  //     return el.roleApplicable.includes(selectedRole.value)
  //   } else {
  //     return true
  //   }
  // })
  const _seasonPasses = (seasonPassData || []).filter(el => {
    if (selectedRole) {
      return el.roleApplicable.includes(selectedRole.value)
    } else {
      return true
    }
  })

  const seasonTypeOptions = map(_seasonPasses || [], el => {
    return {
      value: el._id,
      label: el.seasonTitle,
    }
  })

  const requestedSeasonTypeOptions = map(_seasonPasses || [], el => {
    return {
      value: el._id,
      label: el.seasonTitle,
    }
  })

  delete statusTypes.Offline
  let statusTypeOptions = map(statusTypes, (key, i) => {
    return {
      value: `${key}`,
      label: `${statusTypes[key]}`,
    }
  })
  statusTypeOptions.unshift({ value: "All", label: "All" })

  const stationOptions = map(primaryStations, el => {
    return {
      value: `${el.trim()}`,
      label: `${el.trim()}`,
    }
  })

  let rows = []
  if (user) {
    rows.push(user.id)
  }

  const _expiryDate = validation.values.tempVehicleExpiryDate
    ? moment(validation.values.tempVehicleExpiryDate).format(dateformat.default)
    : ""

  const _scheduleChangeDate = validation.values.scheduleChangeDate
    ? moment(validation.values.scheduleChangeDate).format(dateformat.default)
    : ""

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  const handleResonTextChange = (e) => {
    setReasonText(e);
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleUpdateClick}
        // onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        text={
          // user?.approvedStatus == statusTypes.Approved
          user?.approvedStatus == statusTypes.Approved
            ? "Yes, Approve it!"
            : "Yes, Reject it!"
        }
        icon={
          user?.status == statusTypes.Approved
            ? "mdi mdi-account-check"
            : "mdi mdi-account-remove"
        }
        iconColor={
          user?.approvedStatus === statusTypes.Approved
            ? "text-success"
            : "text-dark"
        }
        childComponent={
          user?.approvedStatus == statusTypes.Approved ? null : (
            <textarea
              name="reasonText"
              className="form-control"
              id="reasonText"
              rows="2"
              onChange={e => handleResonTextChange(e.target.value)}
              onBlur={e => handleResonTextChange(e.target.value)}
              value={reasonText}
              placeholder="Enter reason here..."
            />
          )
        }
        bodyText={
          user?.approvedStatus == statusTypes.Approved
            ? "You want to Approve Season Change"
            : "You want to Reject Season Change Request"
        }
      />
      <div className="page-content">
        <MetaTags>
          <title>
            Manage Details Change Approval | {process.env.REACT_APP_TITLE}
          </title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Users"
            breadcrumbItem="Manage User Season Change Approval"
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField={keyField}
                    columns={userListColumns}
                    data={users || []}
                  >
                    {({ paginationProps, paginationTableProps }) => {
                      return (
                        
                      )
                    }}
                  </PaginationProvider> */}
                  <ToolkitProvider
                          keyField={keyField}
                          data={users || []}
                          columns={userListColumns}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8"></Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={keyField}
                                      {...toolkitProps.baseProps}
                                      // {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={node}
                                      noDataIndication={emptyDataMessage}
                                    />

                                    <Modal
                                      isOpen={modal}
                                      toggle={toggle}
                                      className={"modal-lg"}
                                    >
                                      <ModalHeader toggle={toggle} tag="h4">
                                        Update User
                                      </ModalHeader>
                                      <ModalBody>
                                        <Form
                                          onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                          }}
                                        >
                                          <Row form>
                                            <Col xs={12}>
                                              {/* {isEdit && (
                                            <Col md={6}>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Schedule Change
                                                </Label>
                                                <Row className="mb-2">
                                                  <Col
                                                    md={2}
                                                    className="pr-0 pt-1"
                                                  >
                                                    <Switch
                                                      checked={scheduleChange}
                                                      onColor="#626ed4"
                                                      onChange={() =>
                                                        setScheduleChange(
                                                          !scheduleChange
                                                        )
                                                      }
                                                      uncheckedIcon={
                                                        <OffSymbol text="Off" />
                                                      }
                                                      checkedIcon={
                                                        <OnSymbol text="On" />
                                                      }
                                                    />
                                                  </Col>
                                                  {scheduleChange && (
                                                    <Col
                                                      md={10}
                                                      className="pl-0"
                                                    >
                                                      <input
                                                        className="form-control"
                                                        type="date"
                                                        defaultValue={
                                                          _scheduleChangeDate
                                                        }
                                                        id="scheduleChangeDate"
                                                        name="scheduleChangeDate"
                                                        min={moment().format(
                                                          "YYYY-MM-DD"
                                                        )}
                                                        onChange={
                                                          validation.handleChange
                                                        }
                                                        onBlur={
                                                          validation.handleBlur
                                                        }
                                                        invalid={
                                                          validation.touched
                                                            .scheduleChangeDate &&
                                                          validation.errors
                                                            .scheduleChangeDate
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      {validation.touched
                                                        .scheduleChangeDate &&
                                                      validation.errors
                                                        .scheduleChangeDate ? (
                                                        <FormFeedback type="invalid">
                                                          {
                                                            validation.errors
                                                              .scheduleChangeDate
                                                          }
                                                        </FormFeedback>
                                                      ) : null}
                                                    </Col>
                                                  )}
                                                </Row>
                                              </div>
                                            </Col>
                                          )} */}
                                              <div className="mb-3">
                                                <Row>
                                                  <Col md={6}>
                                                    <label className="form-label">
                                                      Role
                                                    </label>
                                                    <Select
                                                      name="role"
                                                      value={selectedRole}
                                                      onChange={e => {
                                                        setSelectedRole(e)
                                                      }}
                                                      options={roleOptions}
                                                      classNamePrefix="select2-selection"
                                                    />
                                                  </Col>
                                                  <Col md={6}>
                                                    <Label className="form-label">
                                                      Primary Location
                                                    </Label>
                                                    <Select
                                                      name={"primaryStation"}
                                                      value={selectedPMS}
                                                      onChange={e => {
                                                        setCustValidation({
                                                          validPMS: true,
                                                        })
                                                        setPMS(e)
                                                      }}
                                                      options={stationOptions}
                                                      classNamePrefix="select2-selection"
                                                    />

                                                    {!customValidation.validPMS && (
                                                      <div
                                                        className="invalid-feedback"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        Please select primary
                                                        station
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                              <div className="mb-3">
                                                <Row>
                                                  <Col md={7}>
                                                    <Label className="form-label">
                                                      Department / Company Name
                                                    </Label>
                                                    <Input
                                                      name="department"
                                                      //label="Department / Tenanted Site"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .department || ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .department &&
                                                        validation.errors
                                                          .department
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched
                                                      .department &&
                                                    validation.errors
                                                      .department ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .department
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                  <Col md={5}>
                                                    <Label className="form-label">
                                                      Name*
                                                    </Label>
                                                    <Input
                                                      name="name"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .name || ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .name &&
                                                        validation.errors.name
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched.name &&
                                                    validation.errors.name ? (
                                                      <FormFeedback type="invalid">
                                                        {validation.errors.name}
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                </Row>
                                              </div>

                                              <div className="mb-3">
                                                <Row>
                                                  <Col md={7}>
                                                    <Label className="form-label">
                                                      Email*
                                                    </Label>
                                                    <Input
                                                      name="email"
                                                      label="Email"
                                                      type="email"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .email || ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .email &&
                                                        validation.errors.email
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched.email &&
                                                    validation.errors.email ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .email
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                  <Col md={5}>
                                                    <Label className="form-label">
                                                      Mobile Number*
                                                    </Label>
                                                    <Row>
                                                      <Col sm={12}>
                                                        <InputGroup className="mb-2">
                                                          <div className="input-group-prepend">
                                                            <span className="input-group-text">
                                                              +65
                                                            </span>
                                                          </div>
                                                          <Input
                                                            name="mobileNumber"
                                                            label="mobileNumber"
                                                            type="text"
                                                            onChange={
                                                              validation.handleChange
                                                            }
                                                            onBlur={
                                                              validation.handleBlur
                                                            }
                                                            value={
                                                              validation.values
                                                                .mobileNumber ||
                                                              ""
                                                            }
                                                            invalid={
                                                              validation.touched
                                                                .mobileNumber &&
                                                              validation.errors
                                                                .mobileNumber
                                                                ? true
                                                                : false
                                                            }
                                                          />
                                                        </InputGroup>
                                                        {validation.touched
                                                          .mobileNumber &&
                                                        validation.errors
                                                          .mobileNumber ? (
                                                          <FormFeedback type="invalid">
                                                            {
                                                              validation.errors
                                                                .mobileNumber
                                                            }
                                                          </FormFeedback>
                                                        ) : null}
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              </div>
                                              <div className="mb-3">
                                                <h5 className="font-size-14 mb-3 mt-4">
                                                  Primary Vehicle
                                                </h5>
                                              </div>
                                              <div className="mb-3">
                                                <Row>
                                                  <Col md={3}>
                                                    <Row>
                                                      <Col>
                                                        <div className="form-check mt-4 mb-1">
                                                          <input
                                                            type="radio"
                                                            id="customRadio1"
                                                            name="customRadio"
                                                            className="form-check-input"
                                                            defaultChecked={
                                                              vehicleType ==
                                                              vehicleTypes.car
                                                            }
                                                            onChange={e =>
                                                              setVehicleType(
                                                                vehicleTypes.car
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            className="form-check-label"
                                                            htmlFor="customRadio1"
                                                          >
                                                            Car
                                                          </label>
                                                        </div>
                                                      </Col>
                                                      <Col>
                                                        <div className="form-check mt-4">
                                                          <input
                                                            type="radio"
                                                            id="customRadio2"
                                                            name="customRadio"
                                                            className="form-check-input"
                                                            defaultChecked={
                                                              vehicleType ==
                                                              vehicleTypes.bike
                                                            }
                                                            onChange={e =>
                                                              setVehicleType(
                                                                vehicleTypes.bike
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            className="form-check-label"
                                                            htmlFor="customRadio2"
                                                          >
                                                            Bike
                                                          </label>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                  <Col md={4}>
                                                    <Label className="form-label">
                                                      Vehicle Number*
                                                    </Label>
                                                    <Input
                                                      name="vehicleNumber"
                                                      label="vehicleNumber"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .vehicleNumber || ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .vehicleNumber &&
                                                        validation.errors
                                                          .vehicleNumber
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched
                                                      .vehicleNumber &&
                                                    validation.errors
                                                      .vehicleNumber ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .vehicleNumber
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                  <Col md={5}>
                                                    <Label className="form-label">
                                                      In Vehicle Unit*
                                                    </Label>
                                                    <Input
                                                      name="inVehicleUnit"
                                                      label="inVehicleUnit"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .inVehicleUnit || ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .inVehicleUnit &&
                                                        validation.errors
                                                          .inVehicleUnit
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched
                                                      .inVehicleUnit &&
                                                    validation.errors
                                                      .inVehicleUnit ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .inVehicleUnit
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                </Row>
                                              </div>
                                              {isEdit && (
                                                <>
                                                  <div className="mb-3">
                                                    <h5 className="font-size-14 mb-3 mt-4">
                                                      Temporary Vehicle
                                                    </h5>
                                                  </div>
                                                  <div className="mb-3">
                                                    <Row>
                                                      <Col md={4}>
                                                        <Label className="form-label">
                                                          Vehicle Number*
                                                        </Label>
                                                        <Input
                                                          name="tempVehicleNo"
                                                          label="tempVehicleNo"
                                                          type="text"
                                                          onChange={
                                                            validation.handleChange
                                                          }
                                                          onBlur={
                                                            validation.handleBlur
                                                          }
                                                          value={
                                                            validation.values
                                                              .tempVehicleNo ||
                                                            ""
                                                          }
                                                          invalid={
                                                            validation.touched
                                                              .tempVehicleNo &&
                                                            validation.errors
                                                              .tempVehicleNo
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                        {validation.touched
                                                          .tempVehicleNo &&
                                                        validation.errors
                                                          .tempVehicleNo ? (
                                                          <FormFeedback type="invalid">
                                                            {
                                                              validation.errors
                                                                .tempVehicleNo
                                                            }
                                                          </FormFeedback>
                                                        ) : null}
                                                      </Col>
                                                      <Col md={8}>
                                                        <Label className="form-label">
                                                          In Vehicle Unit*
                                                        </Label>
                                                        <Input
                                                          name="tempInVehicleUnit"
                                                          label="tempInVehicleUnit"
                                                          type="text"
                                                          onChange={
                                                            validation.handleChange
                                                          }
                                                          onBlur={
                                                            validation.handleBlur
                                                          }
                                                          value={
                                                            validation.values
                                                              .tempInVehicleUnit ||
                                                            ""
                                                          }
                                                          invalid={
                                                            validation.touched
                                                              .tempInVehicleUnit &&
                                                            validation.errors
                                                              .tempInVehicleUnit
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                        {validation.touched
                                                          .tempInVehicleUnit &&
                                                        validation.errors
                                                          .tempInVehicleUnit ? (
                                                          <FormFeedback type="invalid">
                                                            {
                                                              validation.errors
                                                                .tempInVehicleUnit
                                                            }
                                                          </FormFeedback>
                                                        ) : null}
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                  <div className="mb-3">
                                                    <Row>
                                                      <Col md={4}>
                                                        <Label className="form-label">
                                                          Expiry Date*
                                                        </Label>
                                                        <input
                                                          className="form-control"
                                                          type="date"
                                                          placeholder={
                                                            "DD-MM-YYYY"
                                                          }
                                                          defaultValue={
                                                            _expiryDate
                                                          }
                                                          min={moment().format(
                                                            "YYYY-MM-DD"
                                                          )}
                                                          id="tempVehicleExpiryDate"
                                                          name="tempVehicleExpiryDate"
                                                          onChange={
                                                            validation.handleChange
                                                          }
                                                          onBlur={
                                                            validation.handleBlur
                                                          }
                                                          invalid={
                                                            validation.touched
                                                              .tempVehicleExpiryDate &&
                                                            validation.errors
                                                              .tempVehicleExpiryDate
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                        {validation.touched
                                                          .tempVehicleExpiryDate &&
                                                        validation.errors
                                                          .tempVehicleExpiryDate ? (
                                                          <FormFeedback type="invalid">
                                                            {
                                                              validation.errors
                                                                .tempVehicleExpiryDate
                                                            }
                                                          </FormFeedback>
                                                        ) : null}
                                                      </Col>
                                                      <Col md={8}>
                                                        <Label className="form-label">
                                                          Reason
                                                        </Label>
                                                        <textarea
                                                          name="tempVehicleReason"
                                                          className="form-control"
                                                          id="tempVehicleReason"
                                                          rows="3"
                                                          onChange={
                                                            validation.handleChange
                                                          }
                                                          onBlur={
                                                            validation.handleBlur
                                                          }
                                                          value={
                                                            validation.values
                                                              .tempVehicleReason ||
                                                            ""
                                                          }
                                                        ></textarea>
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                  <div className="mb-3"></div>
                                                </>
                                              )}
                                            </Col>
                                          </Row>
                                          <div className="mb-3">
                                            <Row>
                                              <Col md={6}>
                                                <label className="form-label">
                                                  Current Season Type
                                                </label>
                                                <Select
                                                  name={"currentSeasonType"}
                                                  value={selectedSeason}
                                                  onChange={e => {
                                                    setSeason(e)
                                                  }}
                                                  options={seasonTypeOptions}
                                                  classNamePrefix="select2-selection"
                                                  isDisabled={true}
                                                />
                                              </Col>
                                              <Col md={6}>
                                                <label className="form-label">
                                                  New Season Type
                                                </label>
                                                <Select
                                                  name={"seasonType"}
                                                  value={
                                                    selectedRequestedSeason
                                                  }
                                                  // value={requestedSeasonType}
                                                  onChange={e => {
                                                    setRequestedSeason(e)
                                                  }}
                                                  options={
                                                    requestedSeasonTypeOptions
                                                  }
                                                  classNamePrefix="select2-selection"
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                          <Row>
                                            <Col className="mt-4">
                                              <div className="text-end">
                                                <button
                                                  type="submit"
                                                  className="btn btn-success save-user"
                                                >
                                                  Update User
                                                </button>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Form>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              {/* <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row> */}
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

UserDetailChangeApproval.propTypes = {}

export default withRouter(UserDetailChangeApproval)
